import React, { useEffect, useRef, useState } from 'react';
import './Detail.css';
import { Link, useNavigate, useParams } from 'react-router-dom';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Productcard from '../../Components/Productcard/Productcard';
import { useAuth } from '../../Context/Authcontext';
import Cartstrip from '../../Components/Cartstrip/Cartstrip';

function Detail() {

    const { id } = useParams();
    const navigate = useNavigate();
    const { userdata, setUserdata, isloggedin, login } = useAuth();
    const [qunatity, setQuantity] = useState(1);
    const [prodata, setProdata] = useState({});
    const [colorind, setColorind] = useState(0);
    const [imgurl, setImgurl] = useState([]);
    const [allpro, setAllpro] = useState([]);
    const [relatedpros, setRelatedpros] = useState([]);
    const [isreadmore, setIsreadmore] = useState(false);
    const [logpop, setLogpop] = useState(false);
    const [canpop, setCanpop] = useState(false);
    const [confirmpop, setConfirmpop] = useState(false);
    const [loaderdis, setLoaderdis] = useState('none');
    const [popind, setPopind] = useState(0);
    const [mobno, setMobno] = useState('');
    const [numpop, setNumpop] = useState('none');
    const [isincart, setIsincart] = useState(false);
    const [iscart, setIscart] = useState(false);
    const [pendingcart, setPendingcart] = useState(false);
    const [banner, setBanner] = useState('');
    const [image, setImage] = useState(null);

    const [hoveredStar, setHoveredStar] = useState(0);
    const [selectedStar, setSelectedStar] = useState(0);
    const [reviewText, setReviewText] = useState("");
    const [reviews, setReviews] = useState([]);
    const [email, setEmail] = useState('');
    const [showOffers, setShowOffers] = useState(false);
    const [offerCopied, setOfferCopied] = useState(false);
    const [availableCoupons, setAvailableCoupons] = useState([]);
    const [reviewImgPopup, setReviewImgPopup] = useState(null);

    useEffect(() => {
        fetch('https://pentadeco.in/api/allcoupons')
            .then(res => res.json())
            .then(data => {
                if (data.success) {
                    const now = new Date();
                    const active = data.coupons
                        .filter(c => c.isActive && (!c.expiresAt || new Date(c.expiresAt) > now))
                        .map(c => ({
                            code: c.code,
                            discount: c.discountType === 'percentage' ? `${c.discountValue}% OFF` : `₹${c.discountValue} OFF`,
                            description: c.discountType === 'percentage'
                                ? `Flat ${c.discountValue}% off on all products${c.minOrderAmount ? ` on orders above ₹${c.minOrderAmount}` : ''}`
                                : `Flat ₹${c.discountValue} off${c.minOrderAmount ? ` on orders above ₹${c.minOrderAmount}` : ''}`
                        }));
                    setAvailableCoupons(active);
                }
            })
            .catch(err => console.error('Error fetching coupons:', err));
    }, []);

    const reviewDiv = useRef(null);

    const handleMouseEnter = (index) => {
        setHoveredStar(index);
    };

    const handleMouseLeave = () => {
        setHoveredStar(0);
    };

    const handleStarClick = (index) => {
        setSelectedStar(index);
    };

    const reviewFunc = () => {
        if(!userdata || !userdata?.name || !userdata?.address || selectedStar === 0 || reviewText === ''){
        }else {
            if(File){
                const newformdata = new FormData();
                newformdata.append('images', image);
                fetch(`https://pentadeco.in/api/uploadimg`, {
                    method: 'POST',
                    body: newformdata
                }).then(res => res.json()).then(data => {
                    if(data.success){
                        fetch(`https://pentadeco.in/api/review`, {
                            method: 'POST',
                            headers: { 'Content-Type': "application/json" },
                            body: JSON.stringify({userid: userdata._id, image: data.urls[0], proid: prodata.proid, username: userdata.name, usercity: userdata.address.city, stars: selectedStar, review: reviewText})
                        }).then(res => res.json()).then(smdata => {
                            if(smdata.success){
                                alert("Review posted successfuly!");
                                window.location.reload();
                            }else{
                                alert("Error occured while posting the review, please try again later.");
                            }
                        }).catch(err => console.error('error occured while posting review', err));
                    }
                })
            }else{
                fetch(`https://pentadeco.in/api/review`, {
                    method: 'POST',
                    headers: { 'Content-Type': "application/json" },
                    body: JSON.stringify({userid: userdata._id, proid: prodata.proid, username: userdata.name, usercity: userdata.address.city, stars: selectedStar, review: reviewText})
                }).then(res => res.json()).then(data => {
                    if(data.success){
                        alert("Review posted successfuly!");
                        window.location.reload();
                    }else{
                        alert("Error occured while posting the review, please try again later.");
                    }
                }).catch(err => console.error('error occured while posting review', err));
            }
        }
    };

    const editReviewFunc = (text, star) => {
        setReviewText(text);
        setSelectedStar(star);
        reviewDiv.current?.scrollIntoView({ behavior: "smooth" });
    }

    const deleteReview = (id) => {
        fetch(`https://pentadeco.in/api/reviewdelete/${id}`).then(res => res.json()).then(data => {
            if(data.success){ 
                alert('Review deleted successfuly');
                window.location.reload();
            }else{
                alert("Failed to delete your review, please try again later.");
            }
        }).catch(err => console.error("error occured while deleting the review", err));
    }

    useEffect(() => {
        if(id){
            fetch(`https://pentadeco.in/api/getreviews/${id}`).then(res => res.json()).then(data => {
                if(data.success){
                    setReviews(data.reviews);
                }
            }).catch(err => console.error('error occured while getting the reviews', err));
        }
    }, [id])

    useEffect(() => { window.scrollTo(0, 0); }, []);

    useEffect(() => { window.scrollTo(0, 0); }, [id]);

    // useEffect(() => {
    //     if (userdata) {
    //         fetch(`https://pentadeco.in/api/countview/${id}/${userdata?._id}`).then(res => res.json()).then(data => console.log(data)).catch(err => console.log('error occured while counting the view ', err));
    //     }
    // }, [userdata, id])

    useEffect(() => {
        if (isloggedin) {
            setPopind(1);
        } else {
            setPopind(0);
        }
    }, [isloggedin]);

    useEffect(() => {
        if (isloggedin) {
            setMobno(userdata?.number);
            setPopind(1);
        } else {
            if (localStorage.getItem('usernum')) {
                setMobno(JSON.parse(localStorage.getItem('usernum')));
                setPopind(1);
            }
        }
    }, [isloggedin, userdata])

    useEffect(() => {
        fetch(`https://pentadeco.in/api/pro/${id}`).then(res => res.json()).then(data => {
            if (data.success) {
                setProdata(data.pro);
            } else {
            }
        }).catch(err => console.error('error occured while getting the single data ', err));
    }, [id]);

    useEffect(() => {
        if(prodata){
            fetch(`https://pentadeco.in/api/products/1/12/${prodata.category}`).then(res => res.json()).then(data => {
                if (data.success) {
                    setAllpro(data.products);
                } else {
                }
            }).catch(err => console.error('error occured while getting all the product ', err));
        }
    }, [prodata]);

    // useEffect(() => {
    //     if (allpro?.length > 0) {
    //         const samecat = allpro?.filter(e => e.category.toLowerCase() === prodata?.category?.toLowerCase());
    //         const rmsame = samecat.filter(e => e.proid !== id);
    //         console.log(rmsame);
    //         setRelatedpros(rmsame);
    //     }
    // }, [allpro, prodata, id])

    useEffect(() => {
        if (prodata?.colornimage && prodata.colornimage[colorind]?.url) {
            setImgurl(prodata.colornimage[colorind].url.split(','));
        }
    }, [prodata, colorind, setImgurl]);

    const estimateTimeFunc = () => {
        const currentDate = new Date();
        const newDate = currentDate;
        newDate.setDate(newDate.getDate() + 3);
        const estimateDate = `${newDate.getDate()} ${newDate.toLocaleDateString('en-US', { month: 'long' })}`;
        newDate.setDate(newDate.getDate() + 6);
        const lastestimateDate = `${newDate.getDate()} ${newDate.toLocaleDateString('en-US', { month: 'long' })}`;
        return { start: estimateDate, end: lastestimateDate };
    };

    const herocaro = {
        customPaging: function (i) {
            return (
                <div className='dot-img p-0'>
                    <img src={prodata.images[i]} alt="" className="img-fluid" style={{aspectRatio: '1/1', objectFit: 'cover'}} />
                </div>
            )
        },
        dots: true,
        infinite: true,
        autoplay: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        pauseOnHover: false,
        responsive: [
            {
                breakpoint: 1000,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: true,
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: true,
                },
            },
        ],
    }

    const firstOrderFunc = () => {
        if (isloggedin) {
            // setConfirmpop(true);
            setLogpop(true);
        } else {
            setLogpop(true);
        };
    };

    const orderNowFunc = () => {
        if (isloggedin) {
            setLoaderdis("flex");
            fetch(`https://pentadeco.in/api/order/${userdata?._id}/${id}`).then(res => res.json()).then(data => {
                if (data.success) {
                    login(data.pro);
                    navigate('/history')
                } else {
                }
                setLoaderdis('none');
            }).catch(err => console.error('error occured while booking a product ', err));
        } else {
            setLogpop(true);
        }
    }

    const nextFunc = () => {
        if (mobno.length === 10) {
            localStorage.setItem("usernum", JSON.stringify(mobno));
            setPopind(1);
        }
    }

    const forOrderFunc = (pla) => {
        setLoaderdis('flex')
        fetch(`https://pentadeco.in/api/order`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                user: mobno,
                productid: prodata.proid,
                platform: pla === 0 ? 'amazon' : 'whatsapp',
                quantity: qunatity
            })
        }).then(res => res.json()).then(data => {
            if (data.success) {
                if (pla === 0) {
                    window.open(prodata.buylink, '_blank');
                } else {
                    window.open('https://wa.me/+910987654321', '_blank');
                };
                setLoaderdis('none');
                setLogpop(false);
            }
        }).catch(err => console.error('error occured while booking fororder ', err));
    };

    // const ourSiteFunc = () => {
    //     if(!isloggedin){
    //         localStorage.setItem('cartpro', id);
    //         navigate('/cart');
    //     }
    // }

    const splitFunc = (str) => {
        const imgFst = str.split(',');
        return imgFst;
    }

    const siteOrderFunc = () => {
        setLoaderdis('flex')
        if (isloggedin) {
            fetch(`https://pentadeco.in/api/addtocart`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ id: id, quantity: qunatity, proname: prodata?.name })
            }).then(res => res.json()).then(data => {
                if (data.success) {
                    setLoaderdis('none');
                    navigate('/cart');
                    login(data.pro);
                } else {
                    setLoaderdis('none');
                }
            }).catch(err => console.error('error occured while ordering the product form our site ', err));
        } else {
            const loaclCart = localStorage.getItem("cart");
            if (!loaclCart) {
                const cartarr = [{ id: id, quantity: qunatity, proname: prodata?.name }];
                localStorage.setItem('cart', JSON.stringify(cartarr));
                navigate('/cart');
                setLoaderdis('none');
            } else {
                const updatedcart = JSON.parse(loaclCart);
                let found = false;
                updatedcart.forEach(arr => {
                    if (arr.id === id) {
                        arr.quantity = qunatity;
                        localStorage.setItem('cart', JSON.stringify(updatedcart));
                        navigate('/cart');
                        setLoaderdis('none');
                        found = true;
                    }
                });
                if (!found) {
                    updatedcart.push({ id: id, quantity: qunatity, proname: prodata?.name });
                    localStorage.setItem('cart', JSON.stringify(updatedcart));
                    navigate('/cart');
                    setLoaderdis('none');
                }
            }
        }
    }

    useEffect(() => {
        if(userdata && userdata?.cart?.length > 0){
            setIscart(true);
        }else{
            setIscart(false);
        }
    }, [userdata])

    useEffect(() => {
        if (userdata && userdata?.cart?.length > 0 && prodata?.proid) {
            const foundcart = userdata.cart.find(pro => pro.id === prodata.proid);
            if (foundcart) {
                setQuantity(parseInt(foundcart.quantity));
                setIsincart(true);
            } else {
                setIsincart(false);
            }
        }
    }, [userdata, prodata])

    const addtoCartFunc = (num, now) => {
        if(isloggedin){
            setLoaderdis('flex');
            fetch(`https://pentadeco.in/api/addtocart`, {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({productId: id, quantity: num, userId: userdata?._id})
            }).then(res => res.json()).then(data => {
                setLoaderdis('none');
                if(data.success){
                    setUserdata(prev => ({...prev, cart: data.cart}));
                    const foundcart = data.cart.find(pro => pro.id === prodata.proid);
                    if (foundcart) {
                        setQuantity(parseInt(foundcart.quantity));
                        setIsincart(true);
                    } else {
                        setIsincart(false);
                    }
                    if(now) navigate('/cart');
                }
            }).catch(err => {
                setLoaderdis('none');
                console.error("error occured while adding to the cart", err);
            });
        }else{
            setNumpop('flex');
        }
    }

    const signupFunc = () => {
        if(mobno && mobno.length === 10 && email.length > 0 && email.includes('@') && email.includes('.')){
            fetch('https://pentadeco.in/api/signup', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({number: mobno, email: email})
            }).then(res => res.json()).then(data => {
                if(data.success){
                    login(data.user);
                    setPendingcart(true)
                    setUserdata(data.user);
                    setNumpop("none")
                }else{
                }
            })
        }else{
            alert("Enter a valid number!");
        }
    };

    useEffect(() => {
        if(pendingcart){
            addtoCartFunc(1);
        }
    }, [pendingcart])

    const catBanners = [
        {category: "capsule mug", banner: '/assets/banner/detail-banner-capsule-mug.webp'},
        {category: "inside colour mug", banner: '/assets/banner/detail-banner-inside-color-mug.webp'},
        {category: "Magic Mug", banner: '/assets/banner/detail-banner-magic-mug.webp'},
        {category: "White Mug", banner: '/assets/banner/detail-banner-white-mug.webp'},
        {category: "Bag Tag", banner: '/assets/banner/detail-banner-bag-tag.webp'},
        {category: "Mouse Pad", banner: '/assets/banner/detail-banner-mouse-pad.webp'},
        {category: "Coasters", banner: '/assets/banner/detail-banner-coaster.webp'},
        {category: "Coke Bottle", banner: '/assets/banner/detail-banner-coke-bottle.webp'},
        {category: "Sipper Water Bottle (600ml)", banner: '/assets/banner/detail-banner-sipper-bottle.webp'},
        {category: "Sipper Water Bottle (750ml)", banner: '/assets/banner/detail-banner-sipper-bottle.webp'},
        {category: "Sports Water Bottle", banner: '/assets/banner/detail-banner-sports-bottle.webp'},
        {category: "Set of 2 Cups", banner: '/assets/banner/detail-banner-set-of-2-cup.webp'},
        {category: "Frosted Glass Jar", banner: '/assets/banner/detail-banner-froster-glass-jar.webp'},
        {category: "Money Bank", banner: '/assets/banner/detail-banner-money-bank.webp'},
        {category: "Wall Decor", banner: '/assets/banner/detail-banner-wall-decor.webp'},
        {category: "bags", banner: '/assets/banner/detail-banner-tote-bag.webp'},
        {category: "copper bottle", banner: '/assets/banner/detail-banner-copper-bottle.webp'},
    ];

    useEffect(() => {
        if(prodata.category){
            const foundbanner = catBanners.find(pro => pro.category.toLowerCase() === prodata.category.toLowerCase())
            if(foundbanner) setBanner(foundbanner.banner);
        }
    }, [prodata])

    // Compute review statistics (outside JSX for reliability)
    const reviewTotal = reviews.length;
    const reviewAvg = reviewTotal > 0
        ? (reviews.reduce((s, r) => s + Number(r.stars), 0) / reviewTotal).toFixed(1)
        : '0.0';
    const reviewStarCounts = [5, 4, 3, 2, 1].map(s => ({
        star: s,
        count: reviews.filter(r => Number(r.stars) === s).length
    }));
    const reviewMaxCount = Math.max(...reviewStarCounts.map(c => c.count), 1);

    return (
        <div className='main-detail'>
            <div className="container-fluid mx-auto mt-4 px-0">
                <div className="row container-fluid mx-auto">
                    <div className="col-md-1"></div>
                    <div className="col-md-4 p-0 pt-0 mb-4 detail-img-wrap">
                        {
                            prodata.images?.length > 0 && ( 
                                <Slider {...herocaro}>
                                    {
                                        prodata?.images.map((img, ind) => (
                                            <div key={ind  } className="detail-img rounded-brand overflow-hidden bg-brand-light">
                                                <img src={img} alt="girl img" className="img-fluid w-100" />
                                            </div>
                                        ))
                                    }
                                </Slider>
                            )
                        }
                    </div>
                    <div className="col-md-7">
                        <div className="name-wrap">
                            <span className="detail-category-badge text-capitalize">{prodata.category}</span>
                            <p className="mb-0 fs-4 body-font-bold lh-sm text-capitalize mt-2">{prodata.name}</p>
                        </div>
                        <div className="price-wrap mt-3 d-flex align-items-center flex-wrap gap-2">
                            <p className="fs-2 mb-0 body-font-bold lh-sm"><sup className="body-font-body fs-5">₹</sup>{prodata.discountprice}</p>
                            {prodata.price && prodata.discountprice && prodata.price > prodata.discountprice && (
                                <>
                                    <p className="mb-0 fs-5 body-font-regular text-muted lh-sm text-decoration-line-through">₹{prodata.price}</p>
                                    <span className="detail-discount-badge">{Math.round((prodata.price - prodata.discountprice) / prodata.price * 100)}% off</span>
                                </>
                            )}
                        </div>
                        <p className="mb-0 body-font-regular text-muted fs-esm lh-sm mt-1">Inclusive of all taxes</p>

                        {availableCoupons.length > 0 && (
                            <div className="detail-offer-wrap mt-3">
                                <div className="detail-offer-strip" onClick={() => setShowOffers(s => !s)}>
                                    <div className="d-flex align-items-center gap-2">
                                        <i className="fi fi-rs-tag detail-offer-icon"></i>
                                        <span className="detail-offer-strip-text">{availableCoupons.length} Offer{availableCoupons.length > 1 ? 's' : ''} Available</span>
                                    </div>
                                    <i className={`fi fi-rs-angle-${showOffers ? 'up' : 'down'} detail-offer-chevron`}></i>
                                </div>
                                {showOffers && (
                                    <div className="detail-offer-panel">
                                        {availableCoupons.map((coupon, i) => (
                                            <div key={i} className="detail-coupon-card">
                                                <div className="detail-coupon-top">
                                                    <span className="detail-coupon-discount">{coupon.discount}</span>
                                                    <p className="detail-coupon-desc">{coupon.description}</p>
                                                </div>
                                                <div className="detail-coupon-code-row">
                                                    <span className="detail-coupon-code">{coupon.code}</span>
                                                    <button className="detail-coupon-copy-btn" onClick={() => {
                                                        navigator.clipboard.writeText(coupon.code).then(() => {
                                                            setOfferCopied(coupon.code);
                                                            setTimeout(() => setOfferCopied(false), 2000);
                                                        });
                                                    }}>
                                                        {offerCopied === coupon.code
                                                            ? <><i className="fi fi-rs-check"></i> Copied!</>
                                                            : <><i className="fi fi-rs-copy"></i> Copy Code</>
                                                        }
                                                    </button>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                        )}
                        {/* <div className="mt-3 pt-4 border-top">
                        <h2 className="fs-5 body-font-bold">Colors</h2>
                        <div className="d-flex flex-wrap">
                            {
                                prodata?.colornimage?.map((col, ind) => (
                                    <div key={ind} onClick={()=> setColorind(ind)} className="product-color me-2" style={{backgroundColor: col.color}}></div>
                                ))
                            }
                        </div>
                    </div> */}
                        <div className="detail-actions mt-4">
                            {/* Row 1: qty control + add to cart inline */}
                            <div className="detail-qty-cart-row">
                                <div className="detail-qty-ctrl">
                                    <button className="detail-qty-btn" onClick={() => addtoCartFunc(-1)}>−</button>
                                    <span className="detail-qty-val">{qunatity}</span>
                                    <button className="detail-qty-btn" onClick={() => addtoCartFunc(1)}>+</button>
                                </div>
                                {isincart ? (
                                    <button disabled className="detail-cart-btn detail-cart-btn--disabled">
                                        <i className="fi fi-ss-shopping-cart me-2"></i>Already in Cart
                                    </button>
                                ) : (
                                    <button className="detail-cart-btn" onClick={() => addtoCartFunc(1)}>
                                        <i className="fi fi-ss-shopping-cart me-2"></i>Add to Cart
                                    </button>
                                )}
                            </div>
                            {/* Row 2: buy it now full width */}
                            <div className="mt-3">
                                {userdata?.order?.includes(id) ? (
                                    <button className="detail-buy-btn detail-buy-btn--cancel w-100" onClick={() => setCanpop(true)}>
                                        Cancel Order
                                    </button>
                                ) : (
                                    <button className="detail-buy-btn w-100" onClick={() => isincart ? window.location.href = '/cart' : addtoCartFunc(1, true)}>
                                        Buy it Now
                                    </button>
                                )}
                            </div>
                            {/* Row 3: delivery chips */}
                            <div className="detail-delivery-chips mt-3">
                                <span className="detail-chip"><i className="fi fi-ss-truck-side detail-chip-icon"></i>Free Delivery</span>
                                <span className="detail-chip"><i className="fi fi-ss-money-bill-wave detail-chip-icon"></i>COD Available</span>
                                <span className="detail-chip"><i className="fi fi-ss-rotate-right detail-chip-icon"></i>Easy Returns</span>
                            </div>
                            <div className="mob-buy-btn row m-0 py-2 px-0 bg-white border-0"></div>
                        </div>

                        {prodata.description && (
                            <div className="detail-desc-wrap mt-4">
                                <p className="detail-section-heading">About this product</p>
                                <p className="mb-0 detail-desc-text">{prodata.description}</p>
                            </div>
                        )}

                        <div className="detail-spec-wrap mt-4">
                            <p className="detail-section-heading">Specifications</p>
                            <div className="detail-spec-table">
                                {prodata?.features?.[0]?.description && (
                                    <div className="detail-spec-row">
                                        <span className="detail-spec-label"><i className="fi fi-ss-object-ungroup me-2"></i>Material</span>
                                        <span className="detail-spec-value">{prodata.features[0].description}</span>
                                    </div>
                                )}
                                {prodata?.features?.[1]?.description && (
                                    <div className="detail-spec-row">
                                        <span className="detail-spec-label"><i className="fi fi-ss-ruler-combined me-2"></i>Size</span>
                                        <span className="detail-spec-value">{prodata.features[1].description}</span>
                                    </div>
                                )}
                                {prodata?.features?.[2]?.description && (
                                    <div className="detail-spec-row">
                                        <span className="detail-spec-label"><i className="fi fi-ss-glass me-2"></i>Capacity</span>
                                        <span className="detail-spec-value">{prodata.features[2].description}</span>
                                    </div>
                                )}
                                {prodata?.features?.[3]?.description && (
                                    <div className="detail-spec-row">
                                        <span className="detail-spec-label"><i className="fi fi-ss-plant-care me-2"></i>Care</span>
                                        <span className="detail-spec-value">{prodata.features[3].description}</span>
                                    </div>
                                )}
                            </div>
                        </div>



                        <div className="accordion mt-5 border rounded-brand overflow-hidden d-none" id="accordionExample">
                            {/* <div className="accordion-item border-0 border-bottom">
                            <h2 className="accordion-header">
                            <button className="accordion-button shadow-none border-0" type="button" data-bs-toggle="collapse" data-bs-target="#collapseZero" aria-expanded="true" aria-controls="collapseZero">
                                Delivery Estimates
                            </button>
                            </h2>
                            <div id="collapseZero" className="accordion-collapse collapse show" data-bs-parent="#accordionExample">
                                <div className="accordion-body">
                                    <div className="extra-info-wrap">
                                        <p className="mb-2 body-font-semibold"><i className="far fa-clock me-2"> </i> Estimate Time: <span className="text-muted ms-2">{`${estimateTimeFunc().start} - ${estimateTimeFunc().end}`}</span></p>
                                        <p className="mb-2 body-font-semibold"><i className="fas fa-th-large me-2"> </i> Category: <span className="text-muted ms-2">{prodata?.category}</span></p>
                                        <p className="mb-2 body-font-semibold"><i className="fas fa-tag me-2"> </i> 
                                            Tag: <span className="text-muted ms-2 text-capitalize">{
                                                prodata?.tag?.map((tag, ind) => (
                                                    `${tag}${ind === prodata?.tag?.length -1? '': ','} `
                                                ))
                                            }</span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div> */}
                            <div className="accordion-item border-0 border-bottom">
                                <h2 className="accordion-header">
                                    <button className="accordion-button shadow-none border-0" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                        Product Specifications
                                    </button>
                                </h2>
                                <div id="collapseOne" className="accordion-collapse collapse" data-bs-parent="#accordionExample">
                                    <div className="accordion-body">
                                        <div className="description-wrap">
                                            <p className="mb-0 text-muted body-font-medium">
                                                {prodata?.description?.length > 300 && !isreadmore ? prodata?.description?.slice(0, 300) + '...' : prodata?.description}
                                                {
                                                    prodata?.description?.length > 300 && (
                                                        <span className="read-more text-primary cursor-pointer" style={{ display: isreadmore && 'none' }} onClick={() => setIsreadmore(true)}>Read more</span>
                                                    )
                                                }
                                                {
                                                    prodata?.description?.length > 300 && (
                                                        <span className="read-less text-primary cursor-pointer" style={{ display: isreadmore ? 'inline' : 'none' }} onClick={() => setIsreadmore(false)}>Read less</span>
                                                    )
                                                }
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="accordion-item border-0 border-bottom">
                                <h2 className="accordion-header">
                                    <button className="accordion-button shadow-none border-0 collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                        Product Details
                                    </button>
                                </h2>
                                <div id="collapseTwo" className="accordion-collapse collapse" data-bs-parent="#accordionExample">
                                    <div className="accordion-body">
                                        <div className="mt-0 pt-0">
                                            {
                                                prodata?.features?.map((feat, ind) => (
                                                    <div key={ind} className="row px-2">
                                                        <div className="col-5 p-2 text-capitalize body-font-semibold">{feat.name}</div>
                                                        <div className="col-7 p-2 text-capitalize text-muted">{feat.description}</div>
                                                    </div>
                                                ))
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="accordion-item border-0">
                                <h2 className="accordion-header">
                                    <button className="accordion-button shadow-none border-0 collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                        Perks
                                    </button>
                                </h2>
                                <div id="collapseThree" className="accordion-collapse collapse" data-bs-parent="#accordionExample">
                                    <div className="accordion-body">
                                        <div className="row align-items-center">
                                            {/* <div className="col-md-1 col-3 mb-3">
                                            <img src="/assets/shipping-icon.png" alt="" className="img-fluid w-100" />
                                        </div> */}
                                            <div className="col-md-11 col-9 mb-3">
                                                <p className="mb-0 body-font-semibold">Free Shipping</p>
                                                <p className="mb-0 text-muted">Free shpping on order over ₹2000.</p>
                                            </div>
                                            {/* <div className="col-md-1 col-3 mb-3">
                                            <img src="/assets/24-7-icon.png" alt="" className="img-fluid w-100" />
                                        </div> */}
                                            <div className="col-md-11 col-9 mb-3">
                                                <p className="mb-0 body-font-semibold">24 / 7 Support</p>
                                                <p className="mb-0 text-muted">24/7 customer support from our team.</p>
                                            </div>
                                            {/* <div className="col-md-1 col-3 mb-3">
                                            <img src="/assets/guarantee-icon.png" alt="" className="img-fluid w-100" />
                                        </div> */}
                                            <div className="col-md-11 col-9">
                                                <p className="mb-0 body-font-semibold">Guarantee Return</p>
                                                <p className="mb-0 text-muted">Not impressed? Get a refund.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container mt-5 pt-5 border-top">
                    <div className="row align-items-stretch">
                        <div ref={reviewDiv} className="col-md-5 mb-5">
                            <h2 className="fs-5 mb-4 body-font-bold">Write a Reviews</h2>
                            <div className="w-100" style={{position: 'sticky', top: '0px'}}>
                                <p className="mb-0">
                                    {[1, 2, 3, 4, 5].map((index) => (
                                    <i
                                        key={index}
                                        className={`fi fi-ss-star fs-1 me-1 ${
                                        index <= (hoveredStar || selectedStar)
                                            ? "text-warning"
                                            : "text-secondary"
                                        }`}
                                        style={{ cursor: "pointer", transition: "color 0.2s" }}
                                        onMouseEnter={() => handleMouseEnter(index)}
                                        onMouseLeave={handleMouseLeave}
                                        onClick={() => handleStarClick(index)}
                                    ></i>
                                    ))}
                                </p>
                                <textarea
                                    type="text"
                                    rows={5}
                                    disabled={!userdata.address || !userdata.name}
                                    className="form-control mb-2 mt-2 shadow-none outline-none border border-brand-primary rounded-brand"
                                    placeholder="Write a review!"
                                    value={reviewText}
                                    onChange={(e) => setReviewText(e.target.value)}
                                />
                                <input type="file" className="form-control rounded-brand-primary rounded-3 mb-3 mt-3" onChange={(e) => setImage(e.target.files[0])} />
                                <button 
                                    disabled={!userdata.address || !userdata.name}
                                    className="btn btn-brand-secondary rounded-pill w-100 body-font-semibold" 
                                    onClick={reviewFunc}
                                >
                                    POST
                                </button>
                            </div>
                        </div>
                        <div className="col-md-7 mb-5">
                            <h2 className="fs-5 body-font-bold mb-4">Reviews</h2>

                            {/* Rating summary */}
                            {reviewTotal > 0 && (
                                <div className="review-summary mb-4">
                                    <div className="review-summary-top">
                                        <span className="review-avg-num">{reviewAvg}</span>
                                        <div className="review-avg-meta">
                                            <p className="mb-1">
                                                {[1, 2, 3, 4, 5].map(s => (
                                                    <i key={s} className={`fi fi-ss-star fs-sm me-1 ${s <= Math.round(Number(reviewAvg)) ? 'text-warning' : 'text-secondary'}`}></i>
                                                ))}
                                            </p>
                                            <p className="mb-0 text-muted fs-sm">{reviewTotal} {reviewTotal === 1 ? 'rating' : 'ratings'}</p>
                                        </div>
                                    </div>
                                    <div className="review-bars mt-3">
                                        {reviewStarCounts.map(({ star, count }) => (
                                            <div key={star} className="review-bar-row">
                                                <span className="review-bar-label">{star}.0</span>
                                                <div className="review-bar-track">
                                                    <div className="review-bar-fill" style={{ width: `${(count / reviewMaxCount) * 100}%` }}></div>
                                                </div>
                                                <span className="review-bar-count">{count} {count === 1 ? 'review' : 'reviews'}</span>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}

                            {/* Individual review cards */}
                            <div className="review-card-wrapper">
                                {reviewTotal > 0 ? reviews.map((pro, ind) => (
                                    <div key={ind} className="review-card-new mb-3">
                                        <div className="d-flex justify-content-between align-items-start mb-2">
                                            <div className="d-flex align-items-center gap-2">
                                                <div className="review-avatar">{pro.username?.[0]?.toUpperCase()}</div>
                                                <div>
                                                    <p className="mb-0 body-font-semibold lh-sm">{pro.username}</p>
                                                    <p className="mb-0 text-muted fs-sm lh-sm">{pro.usercity}</p>
                                                </div>
                                            </div>
                                            <div className="d-flex align-items-center">
                                                <span className="review-star-badge">{pro.stars}.0 <i className="fi fi-ss-star" style={{position: 'relative', bottom: '-1px'}}></i></span>
                                                {userdata._id === pro.userid && (
                                                    <div className="d-flex ms-2">
                                                        <button className="btn btn-brand-secondary py-1 rounded-pill px-2 me-1" onClick={() => editReviewFunc(pro.review, pro.stars)}>
                                                            <i className="fi fi-ss-pencil fs-sm"></i>
                                                        </button>
                                                        <button className="btn btn-brand-secondary py-1 rounded-pill px-2" onClick={() => deleteReview(pro._id)}>
                                                            <i className="fi fi-ss-trash fs-sm"></i>
                                                        </button>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                        <p className="mb-0 fs-sm" style={{color: '#444', lineHeight: '1.65'}}>{pro.review}</p>
                                        {pro?.image && pro.image !== '' && (
                                            <img src={pro.image} alt="review preview" className="img-fluid mt-2" style={{maxWidth: '180px', borderRadius: '10px', cursor: 'pointer'}} onClick={() => setReviewImgPopup(pro.image)} />
                                        )}
                                    </div>
                                )) : (
                                    <p className="mb-0 text-center text-muted body-font-bold py-5">No reviews yet</p>
                                )}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="banner-wrap my-5">
                    <div className="banner-strip"></div>
                    <img src="/assets/banner/ALL PRODUCTS.webp" alt="All Products" className="img-fluid w-100" />
                </div>

                <div className="suggetions-wrap container mt-0 px-0">
                    <h2 className="fs-5 body-font-bold">Related Products</h2>
                    <div className="mt-4 row p-0 m-0">
                        {/* <Slider {...relatedcaro}> */}
                        {
                            allpro?.map((pro, ind) => (
                                <div key={ind} className="col-md-3 col-6 p-1">
                                    <Productcard coverimg={pro.images[0]} tag={pro.status} category={pro.category} saletxt={pro.spinningtxt} name={pro.name} price={pro.discountprice} preprice={pro.price} id={pro.proid} />
                                </div>
                            ))
                        }
                        {/* </Slider> */}
                    </div>
                    <div className="new-cards row px-2 mb-5">
                        {
                            prodata.length > 0 && (
                                prodata.slice(0, 4).map((pro, ind) => (
                                    <div key={ind} className="col-md-3 col-6 p-1">
                                        <Productcard coverimg={pro.images[0]} tag={pro.status} category={pro.category} saletxt={pro.spinningtxt} name={pro.name} price={pro.discountprice} preprice={pro.price} id={pro.proid} />
                                    </div>
                                ))
                            )
                        }
                    </div>
                </div>
            </div>
            <div className="full-overlay logpop-wrapper" style={{ display: logpop ? 'flex' : 'none' }}>
                <div className="logpop-wrap d-flex justify-content-end">
                    <p className="mb-0 w-max-content p-1 pe-3 text-white fs-4 cursor-pointer" onClick={() => setLogpop(false)}><i className="fas fa-times"></i></p>
                </div>
                {
                    popind === 0 && (
                        <div className="logpop-wrap bg-white rounded-brand-lg overflow-hidden p-3 py-4">
                            <h2 className="fs-2 mb-1 text-center">Get <span className="body-font-extrabold">Started</span></h2>
                            <p className="mb-4 text-muted text-center fs-sm">Provide you phone number to move forward.</p>
                            <div className="d-flex align-items-center p-0 border border-dark rounded-brand overflow-hidden py-1">
                                <p className="mb-0 body-font-medium px-2 border-end text-nowrap">+ 91</p>
                                <input type="text" name="number" id="number" className=" m-0 form-control shadow-none outline-none border-0 rounded-brand-sm" placeholder='Your number' value={mobno} onChange={(e) => setMobno(e.target.value)} />
                            </div>
                            <button className='btn btn-dark fs-5 rounded-brand w-100 py-2 letter-spacing mt-4' onClick={nextFunc}>NEXT <i className="fas fa-long-arrow-alt-right"></i></button>
                            <p className="fs-sm text-muted text-center mt-4">
                                Lorem ipsum, dolor sit amet consectetur adipisicing elit. Blanditiis, dolor nostrum qui harum numquam sed. Repellat repudiandae eveniet quis itaque, necessitatibus in similique <Link to="/terms-and-conditions" className='nav-link. text-primary'>Terms & Conditions</Link> and <Link to="/privacy-policy" className='nav-link. text-primary'>Privacy Policy</Link>.
                            </p>
                        </div>
                    )
                }
                {
                    popind === 1 && (
                        <div className="logpop-wrap bg-white rounded-brand-lg overflow-hidden p-3 py-4">
                            <h2 className="fs-2 mb-4 text-center">Buy it on</h2>
                            {/* <p className="mb-3 cursor-pointer letter-spacing body-font-light py-3 text-center text-white bg-dark rounded-brand fs-5 lh-sm" onClick={()=> forOrderFunc(0)}><i className="fab fa-amazon me-2"></i>AMAZON <br /> <span className="fs-sm text-light">50% OFF</span></p>
                        <p className="mb-3 cursor-pointer letter-spacing body-font-light py-3 text-center text-white bg-dark rounded-brand fs-5 lh-sm" onClick={()=> forOrderFunc(1)}><i className="fab fa-whatsapp me-2"></i>WHATSAPP <br /> <span className='fs-sm text-light'>30% OFF</span></p>
                        <Link to="/cart" className="nav-link mb-2 letter-spacing body-font-light py-3 text-center text-dark bg-brand-light rounded-brand fs-5"><i className="fas fa-globe me-2"></i>OUR WEBSITE</Link> */}
                            <div className="d-flex align-items-center justify-content-between bg-brand-light border border-dark rounded-pill p-3 mb-3 cursor-pointer" onClick={() => forOrderFunc(0)}>
                                <div className="d-flex align-items-center">
                                    <div className="icon-wrap me-3">
                                        <img src="https://upload.wikimedia.org/wikipedia/commons/4/4a/Amazon_icon.svg" alt="amazon logo" width='40px' className="img-fluid" />
                                    </div>
                                    <div className="btn-text-wrap">
                                        <p className="mb-0 fs-5 body-font-extrabold">Super Fast Delivery</p>
                                        <p className="mb-0 fs-sm letter-spacing text-muted">AMAZON</p>
                                    </div>
                                </div>
                                <div className="arrow-wrap">
                                    <p className="mb-0 arrow-para">
                                        <i className="fas fa-arrow-right text-white fs-4"></i>
                                    </p>
                                </div>
                            </div>
                            <div className="d-flex align-items-center justify-content-between bg-brand-light border border-dark rounded-pill p-3 mb-3 cursor-pointer" onClick={() => forOrderFunc(1)}>
                                <div className="d-flex align-items-center">
                                    <div className="icon-wrap me-3">
                                        <img src="https://upload.wikimedia.org/wikipedia/commons/5/5e/WhatsApp_icon.png" alt="whatsapp logo" width='40px' className="img-fluid" />
                                    </div>
                                    <div className="btn-text-wrap">
                                        <p className="mb-0 fs-5 body-font-extrabold">₹150% OFF</p>
                                        <p className="mb-0 fs-sm letter-spacing text-muted">WHATSAPP</p>
                                    </div>
                                </div>
                                <div className="arrow-wrap">
                                    <p className="mb-0 arrow-para">
                                        <i className="fas fa-arrow-right text-white fs-4"></i>
                                    </p>
                                </div>
                            </div>
                            <div className="d-flex align-items-center justify-content-between bg-brand-light border border-dark rounded-pill p-3 mb-3 cursor-pointer" onClick={siteOrderFunc}>
                                <div className="d-flex align-items-center">
                                    <div className="icon-wrap me-3">
                                        <img src="/assets/homejoylogo.png" alt="amazon logo" width='40px' className="img-fluid" />
                                    </div>
                                    <div className="btn-text-wrap">
                                        <p className="mb-0 fs-5 body-font-extrabold">COD Available</p>
                                        <p className="mb-0 fs-sm letter-spacing text-muted">OUR WEBSITE</p>
                                    </div>
                                </div>
                                <div className="arrow-wrap">
                                    <p className="mb-0 arrow-para">
                                        <i className="fas fa-arrow-right text-white fs-4"></i>
                                    </p>
                                </div>
                            </div>
                        </div>
                    )
                }
                {/* <div className="logpop-wrap bg-white rounded-brand-lg overflow-hidden p-3 py-4">
                <h2 className="fs-2 mb-1 text-center"><span className="body-font-extrabold">Verify</span> Your Number</h2>
                <p className="mb-4 text-muted text-center fs-sm">We've sent OTP on your number.</p>
                <p className="mb-2 body-font-bold fs-5 text-center">Your OTP</p>
                <input type="text" name="number" id="number" className="form-control shadow-none outline-none border border-dark rounded-brand-sm" placeholder='Your number'/>
                <button className='btn btn-dark fs-5 rounded-brand w-100 py-2 letter-spacing mt-4'>NEXT <i className="fas fa-long-arrow-alt-right ms-2"></i></button>
                <p className="fs-sm text-muted text-center mt-4">
                    Lorem ipsum, dolor sit amet consectetur adipisicing elit. Blanditiis, dolor nostrum qui harum numquam sed. Repellat repudiandae eveniet quis itaque, necessitatibus in similique <Link to="/terms-and-conditions" className='nav-link. text-primary'>Terms & Conditions</Link> and <Link to="/privacy-policy" className='nav-link. text-primary'>Privacy Policy</Link>.
                </p>
            </div> */}
            </div>
            <div className="full-overlay" style={{ display: canpop ? 'flex' : 'none' }}>
                <div className="logpop-wrap bg-white rounded-brand-lg overflow-hidden p-3 py-4">
                    <h2 className="fs-4 body-font-bold mb-4 text-center">Do you want to cancele this order ?</h2>
                    <div className="d-flex align-items-center">
                        <button className='btn btn-dark fs-5 rounded-brand w-100 py-2 letter-spacing me-1' onClick={() => { orderNowFunc(); setCanpop(false) }}>YES</button>
                        <button className='btn btn-outline-dark fs-5 rounded-brand w-100 py-2 letter-spacing ms-1' onClick={() => setCanpop(false)}>NO</button>
                    </div>
                </div>
            </div>
            {
                isloggedin && (
                    <div className="full-overlay confirmation-wrap" style={{ display: confirmpop ? 'flex' : 'none' }}>
                        <div className="d-flex justify-content-end confirmation-pop-cross">
                            <div className="w-max-content">
                                <p className="mb-0 cross-para cursor-pointer mb-2" onClick={() => setConfirmpop(false)}><i className="fas fa-times"></i></p>
                            </div>
                        </div>
                        <div className="confirmation-pop bg-white rounded-brand-lg rounded-bottom-0 overflow-hidden p-3 py-4">
                            <h2 className="fs-4 body-font-bold mb-4 text-center">Order Confirmation</h2>
                            <div className="order-detail bg-white rounded-brand border">
                                <div className="py-2 border-bottom p-2">
                                    <p className="mb-0 text-muted body-font-light">Shipping to <span className="body-font-bold text-capitalize">{userdata?.name}</span></p>
                                </div>
                                <div className="py-2 border-bottom p-2 d-flex justify-content-between align-items-center">
                                    <p className="text-muted mb-0">Items:</p>
                                    <p className="mb-0 text-capitalize body-font-bold text-end">₹{prodata.discountprice}</p>
                                </div>
                                <div className="py-2 border-bottom p-2 d-flex justify-content-between align-items-center">
                                    <p className="text-muted mb-0">Delivery:</p>
                                    <p className="mb-0 text-capitalize body-font-bold text-end">₹40</p>
                                </div>
                                <div className="py-2 p-2 d-flex justify-content-between align-items-center">
                                    <p className="mb-0 fs-5 body-font-bold">Total Order:</p>
                                    <p className="mb-0 text-capitalize body-font-bold text-end fs-5 text-success">₹{prodata.discountprice + 40}</p>
                                </div>
                            </div>
                            <div className="user-detail bg-white rounded-brand border mt-4">
                                <div className="py-2 border-bottom p-2">
                                    <p className="mb-0">Deliver to</p>
                                </div>
                                <div className="py-2 border-bottom p-2 d-flex justify-content-between align-items-center">
                                    <p className="text-muted mb-0">Name:</p>
                                    <p className="mb-0 text-capitalize body-font-bold text-end">{userdata?.name}</p>
                                </div>
                                <div className="py-2 border-bottom p-2 d-flex justify-content-between">
                                    <p className="text-muted mb-0">Address:</p>
                                    <p className="mb-0 text-capitalize body-font-bold text-end">{userdata?.address.address}</p>
                                </div>
                                <div className="py-2 border-bottom p-2 d-flex justify-content-between align-items-center">
                                    <p className="text-muted mb-0">Number:</p>
                                    <p className="mb-0 text-capitalize body-font-bold text-end">{userdata?.number}</p>
                                </div>
                                <Link to="/editprofile" className="nav-link p-0 m-0">
                                    <div className="py-2 p-2 d-flex justify-content-between align-items-center cursor-pointer">
                                        <p className="mb-0">Change Details</p>
                                        <p className="mb-0 text-capitalize body-font-bold text-end"><i className="fas fa-chevron-right ms-3"></i></p>
                                    </div>
                                </Link>
                            </div>
                            <div className="user-detail bg-white rounded-brand border mt-4">
                                <div className="py-2 border-bottom p-2">
                                    <p className="mb-0">Product</p>
                                </div>
                                <div className="py-2 border-bottom p-2">
                                    <div className="row p-0 m-0 align-items-center">
                                        <div className="col-4">
                                            <img src={imgurl[0]} alt="product thumbnail" className="img-fluid" />
                                        </div>
                                        <div className="col-8">
                                            <p className="body-font-bold mb-0 text-capitalize">{prodata.name}</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="py-2 border-bottom p-2 d-flex justify-content-between align-items-center">
                                    <p className="text-muted mb-0">Quantity:</p>
                                    <p className="mb-0 text-capitalize body-font-bold text-end">1</p>
                                </div>
                                <div className="py-2 p-2 d-flex justify-content-between align-items-center">
                                    <p className="text-muted mb-0">Payment Method:</p>
                                    <p className="mb-0 text-capitalize body-font-bold text-end">Cash on delivery</p>
                                </div>
                            </div>
                            <div className="p-2">
                                <p className="mb-0 mt-4 text-muted fs-sm">
                                    Lorem ipsum dolor sit amet consectetur adipisicing elit. Perspiciatis enim odio, doloremque, quos ex amet aperiam sapiente cupiditate eligendi repellendus aut eaque incidunt accusantium. Placeat, inventore nam. Quidem, accusamus sequi.
                                </p>
                            </div>
                            {
                                userdata?.order?.includes(id) ? (
                                    <button className="btn btn-outline-dark rounded-pill w-100 letter-spacing mt-4 fs-5 py-2" onClick={() => setCanpop(true)}>CANCLE ORDER</button>
                                ) : (
                                    <button className="btn btn-brand-secondary rounded-pill w-100 letter-spacing mt-4 fs-5 py-2">PLACE ORDER NOW</button>
                                )
                            }
                        </div>
                    </div>
                )
            }
            <div className="full-overlay" style={{ display: loaderdis }}>
                <div className="loader-wrap rounded-brand p-4">
                    <div className="loader-roundedr"></div>
                </div>
            </div>

            <div className="popup-wrap" style={{display: numpop}}>
                <div className="popup bg-brand-light2 p-3 pb-5">
                    <div className="w-max-content ms-auto"><p className="mb-0 w-max-content cursor-pointer" onClick={() => setNumpop('none')}><i className="fi fi-ss-cross-circle text-brand-secondary"></i></p></div>
                    <p className="mb-0 fs-sm mb-1">Your mobile number</p>
                    <div className="d-flex align-item bg-white border rounded-3 p-2 px-3 mb-3">
                        <p className="mb-0 body-font-bold me-2 pe-2 border-end border-2 fs-5">+91</p>
                        <input type="number" className="form-control border-0 p-0 shadow-none outline-none" onChange={(e) => setMobno(e.target.value)} value={mobno} placeholder='Eg. 9876543210' />
                    </div>
                    <p className="mb-0 fs-sm mb-1">Your email address</p>
                    <input type="email" className='form-control rounded-brand-esm shadow-none outline-none' onChange={(e) => setEmail(e.target.value)} value={email} placeholder='Eg. customer@abc.com' />
                    <button className="btn btn-brand-secondary py-2 w-100 mt-3 rounded-3 body-font-bold fs-5" onClick={signupFunc}>Next <i className="fi fi-ss-arrow-small-right" style={{position: 'relative', bottom: '-3px'}}></i></button>
                </div>
            </div>

            {/* {
                iscart && (
                    <div className="cart-strip-wrapper">
                        <div className="cart-strip bg-brand-secondary p-2 ps-4 rounded-pill text-white d-flex align-items-center justify-content-between">
                            <p className="mb-0">
                                <i className="fi fi-ss-shopping-cart me-2"></i>
                                {
                                    userdata?.cart?.length > 0 && (
                                        userdata?.cart?.reduce((total, item) => total + item.quantity, 0)
                                    )
                                } Item
                            </p>
                            <Link to='/cart' className='btn btn-brand-primary rounded-pill'>View cart</Link>
                        </div>
                    </div>
                )
            } */}

            <Cartstrip/>

            {/* Review image popup */}
            {reviewImgPopup && (
                <div className="review-img-overlay" onClick={() => setReviewImgPopup(null)}>
                    <button className="review-img-close" onClick={() => setReviewImgPopup(null)}>
                        <i className="fi fi-ss-cross"></i>
                    </button>
                    <img src={reviewImgPopup} alt="review" className="review-img-full" onClick={e => e.stopPropagation()} />
                </div>
            )}

        </div>
    )
}

export default Detail